// @module Jeske.BSGSTracker.BSGSModule
define('Jeske.BSGSTracker.BSGSModule.View'
,	[
	'jeske_bsgstracker_bsgsmodule.tpl'
	
	,	'Backbone'
    ]
, function (
	jeske_bsgstracker_bsgsmodule_tpl
	
	,	Backbone
)
{
    'use strict';

	// @class Jeske.BSGSTracker.BSGSModule.View @extends Backbone.View
	return Backbone.View.extend({

		template: jeske_bsgstracker_bsgsmodule_tpl

	,	initialize: function (options) {
			var self = this;
			this.container = options.container;
			this.bsgsData = {};
			this.options = options || {};

			if (this.container && this.container.getComponent) {
				this.environment = this.container.getComponent('Environment');
			}

			var userProfile = this.container && this.container.getComponent('UserProfile');
			if (userProfile) {
				userProfile.getUserProfile().then(function(profile) {
					if (!profile.isloggedin) { return; }

					var bsgsData = { promotion: null, kwProgress: 0, sjProgress: 0, isLoggedIn: true };
					if (profile.customfields) {
						profile.customfields.forEach(function(field) {
							switch (field.id) {
								case 'custentity_bsgs_promotion':    bsgsData.promotion  = field.value; break;
								case 'custentity_kw_promo_progress': bsgsData.kwProgress = parseFloat(field.value) || 0; break;
								case 'custentity_sj_promo_progress': bsgsData.sjProgress = parseFloat(field.value) || 0; break;
							}
						});
					}

					if (bsgsData.promotion) {
						self.bsgsData = bsgsData;
						self.render();
					}
				}).catch(function(error) {
					console.error('BSGSTracker: error fetching user profile', error);
				});
			}
		}

	,	events: {
			'click [data-action="close-bsgs-banner"]': 'closeBanner'
		}

	,	closeBanner: function(event) {
			event.preventDefault();
			var self = this;
			
			// Animate the banner sliding up and fading out
			this.$el.animate({
				opacity: 0,
				height: 0,
				paddingTop: 0,
				paddingBottom: 0,
				marginTop: 0,
				marginBottom: 0
			}, 300, function() {
				// Hide completely after animation finishes
				self.$el.css('display', 'none');
			});
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Jeske.BSGSTracker.BSGSModule.View.Context
	,	getContext: function()
		{
			if (!this.bsgsData.promotion || !this.environment) {
				return { showBanner: false };
			}

			// Get tier amounts from configuration using proper getConfig syntax
			var kwTierAmounts = [
				parseFloat(this.environment.getConfig('bsgstracker.kwtier1amount')) || 4000,
				parseFloat(this.environment.getConfig('bsgstracker.kwtier2amount')) || 10000,
				parseFloat(this.environment.getConfig('bsgstracker.kwtier3amount')) || 20000
			];
			var sjTierAmounts = [
				parseFloat(this.environment.getConfig('bsgstracker.sjtier1amount')) || 4000,
				parseFloat(this.environment.getConfig('bsgstracker.sjtier2amount')) || 10000,
				parseFloat(this.environment.getConfig('bsgstracker.sjtier3amount')) || 20000
			];

			// Get progress values from bsgsData (passed from main module)
			var kwProgress = parseFloat(this.bsgsData.kwProgress) || 0;
			var sjProgress = parseFloat(this.bsgsData.sjProgress) || 0;

			var kwTierInfo = this.calculateTierInfo(kwProgress, kwTierAmounts, 'Kwikset Promotion');
			var sjTierInfo = this.calculateTierInfo(sjProgress, sjTierAmounts, 'Schlage Promotion');

			var startDate = this.environment.getConfig('bsgstracker.startdate');
			var endDate = this.environment.getConfig('bsgstracker.enddate');
			var kwiksetTitle = this.environment.getConfig('bsgstracker.kwiksetpromoname') || 'Kwikset Promotion';
			var schlageTitle = this.environment.getConfig('bsgstracker.schlagepromoname') || 'Schlage Promotion';
			var kwInfoUrl = this.environment.getConfig('bsgstracker.kwinfourl') || '#';
			var sjInfoUrl = this.environment.getConfig('bsgstracker.sjinfourl') || '#';

			// Check if current date is within the promotion date range
			var showBanner = this.isWithinDateRange(startDate, endDate);

			return {
				kwTierInfo: kwTierInfo,
				sjTierInfo: sjTierInfo,
				showBanner: showBanner,
				startDate: startDate,
				endDate: endDate,
				kwiksetTitle: kwiksetTitle,
				schlageTitle: schlageTitle,
				kwInfoUrl: kwInfoUrl,
				sjInfoUrl: sjInfoUrl
			};
		}

	,	isWithinDateRange: function(startDateStr, endDateStr) {
			// Return true if no dates are configured (always show banner)
			if (!startDateStr && !endDateStr) {
				return true;
			}
			
			var today = new Date();
			today.setHours(0, 0, 0, 0); // Set to start of day for comparison
			
			var startDate = null;
			var endDate = null;
			
			// Parse start date (MM/DD/YYYY format)
			if (startDateStr) {
				var startParts = startDateStr.split('/');
				if (startParts.length === 3) {
					// Month is 0-indexed in JavaScript Date constructor
					startDate = new Date(parseInt(startParts[2]), parseInt(startParts[0]) - 1, parseInt(startParts[1]));
				}
			}
			
			// Parse end date (MM/DD/YYYY format)
			if (endDateStr) {
				var endParts = endDateStr.split('/');
				if (endParts.length === 3) {
					// Month is 0-indexed in JavaScript Date constructor
					endDate = new Date(parseInt(endParts[2]), parseInt(endParts[0]) - 1, parseInt(endParts[1]));
					endDate.setHours(23, 59, 59, 999); // Set to end of day
				}
			}
			
			// Check if today is within range
			var withinStart = !startDate || today >= startDate;
			var withinEnd = !endDate || today <= endDate;
			
			return withinStart && withinEnd;
		}

	,	calculateTierInfo: function(progress, tierAmounts, brandName) {
			// Ensure all inputs are numbers
			progress = parseFloat(progress) || 0;
			tierAmounts = tierAmounts.map(function(amount) {
				return parseFloat(amount) || 0;
			});
			
			var currentTier = 0;
			var nextTierAmount = tierAmounts[0];
			var progressPercent = 0;
			var amountUntilNext = 0;
			var isMaxTier = false;
			
			// Determine current tier
			if (progress >= tierAmounts[2]) {
				currentTier = 3;
				isMaxTier = true;
				nextTierAmount = tierAmounts[2];
				progressPercent = 100;
			} else if (progress >= tierAmounts[1]) {
				currentTier = 2;
				nextTierAmount = tierAmounts[2];
				progressPercent = ((progress - tierAmounts[1]) / (tierAmounts[2] - tierAmounts[1])) * 100;
				amountUntilNext = tierAmounts[2] - progress;
			} else if (progress >= tierAmounts[0]) {
				currentTier = 1;
				nextTierAmount = tierAmounts[1];
				progressPercent = ((progress - tierAmounts[0]) / (tierAmounts[1] - tierAmounts[0])) * 100;
				amountUntilNext = tierAmounts[1] - progress;
			} else {
				currentTier = 0;
				nextTierAmount = tierAmounts[0];
				progressPercent = (progress / tierAmounts[0]) * 100;
				amountUntilNext = tierAmounts[0] - progress;
			}
			
			// Ensure all return values are safe numbers
			return {
				brandName: brandName || 'Unknown',
				currentTier: currentTier,
				nextTier: isMaxTier ? 3 : currentTier + 1,
				progress: (parseFloat(progress) || 0).toFixed(0),
				nextTierAmount: (parseFloat(nextTierAmount) || 0).toFixed(0),
				amountUntilNext: (parseFloat(amountUntilNext) || 0).toFixed(2),
				progressPercent: Math.min(Math.max(parseFloat(progressPercent) || 0, 0), 100).toFixed(1),
				isMaxTier: isMaxTier
			};
		}
	});
});
